module.exports = __webpack_public_path__ + "img/roofing_svg.34f1b41a.svg";